import { FulfillmentPlanOrderGridStatus } from '../enums/fulfillmentplan-order-grid-status';
import { SalesOrderStatus } from '../enums/sales-order-status';

class SalesOrderStatusServiceClass {
  determineIfAwaitingPayment(fulfillmentPlans) {
    return fulfillmentPlans.every((fp) => {
      return fp.orderGridStatus === FulfillmentPlanOrderGridStatus.AwaitingPayment.name;
    });
  }

  determineIfPendingFulfillment(fulfillmentPlans) {
    if (fulfillmentPlans.length === 1) {
      return fulfillmentPlans.every((fp) => {
        return fp.orderGridStatus === FulfillmentPlanOrderGridStatus.PendingFulfillment.name;
      });
    }
    const fpArray = fulfillmentPlans.map((shipment) => {
      return shipment.orderGridStatus;
    });
    if (
      fpArray.includes(FulfillmentPlanOrderGridStatus.PendingFulfillment.name) &&
      !fpArray.includes(FulfillmentPlanOrderGridStatus.AwaitingShipment.name)
    ) {
      return true;
    }
    return false;
  }

  determineIfRejectedFulfillment(fulfillmentPlans) {
    if (fulfillmentPlans.length === 1) {
      return fulfillmentPlans[0].orderGridStatus === FulfillmentPlanOrderGridStatus.RejectedFulfillment.name;
    }
    return fulfillmentPlans.some(({ orderGridStatus }) => orderGridStatus === FulfillmentPlanOrderGridStatus.RejectedFulfillment.name);
  }

  determineIfOnHold(fulfillmentPlans) {
    const onHold = FulfillmentPlanOrderGridStatus.OnHold.name;
    const shipped = FulfillmentPlanOrderGridStatus.Shipped.name;
    const atLeastOneIsOnHold = fulfillmentPlans.some((fp) => fp.orderGridStatus === onHold);
    return (
      atLeastOneIsOnHold &&
      fulfillmentPlans.every((fp) => {
        return fp.orderGridStatus === onHold || fp.orderGridStatus === shipped;
      })
    );
  }

  determineIfCancelled(fulfillmentPlans) {
    return fulfillmentPlans.every((fp) => fp.orderGridStatus === FulfillmentPlanOrderGridStatus.Cancelled.name);
  }

  determineIfShipped(fulfillmentPlans) {
    const shipped = FulfillmentPlanOrderGridStatus.Shipped.name;
    const cancelled = FulfillmentPlanOrderGridStatus.Cancelled.name;
    const atLeastOneIsShipped = fulfillmentPlans.some((fp) => fp.orderGridStatus === shipped);
    return (
      atLeastOneIsShipped &&
      fulfillmentPlans.every((fp) => {
        return fp.orderGridStatus === shipped || fp.orderGridStatus === cancelled;
      })
    );
  }

  determineIfAwaitingShipment(fulfillmentPlans) {
    if (this.determineIfAwaitingPayment(fulfillmentPlans)) {
      return false;
    }

    if (this.determineIfCancelled(fulfillmentPlans)) {
      return false;
    }

    if (this.determineIfOnHold(fulfillmentPlans)) {
      return false;
    }

    if (this.determineIfPendingFulfillment(fulfillmentPlans)) {
      return false;
    }

    if (this.determineIfRejectedFulfillment(fulfillmentPlans)) {
      return false;
    }

    if (this.determineIfShipped(fulfillmentPlans)) {
      return false;
    }
    return true;
  }

  getSalesOrderStatus(fulfillmentPlans) {
    if (this.determineIfAwaitingPayment(fulfillmentPlans)) {
      return SalesOrderStatus.AwaitingPayment;
    }

    if (this.determineIfCancelled(fulfillmentPlans)) {
      return SalesOrderStatus.Cancelled;
    }

    if (this.determineIfOnHold(fulfillmentPlans)) {
      return SalesOrderStatus.OnHold;
    }

    if (this.determineIfPendingFulfillment(fulfillmentPlans)) {
      return SalesOrderStatus.PendingFulfillment;
    }

    if (this.determineIfRejectedFulfillment(fulfillmentPlans)) {
      return SalesOrderStatus.RejectedFulfillment;
    }

    if (this.determineIfShipped(fulfillmentPlans)) {
      return SalesOrderStatus.Shipped;
    }

    return SalesOrderStatus.AwaitingShipment;
  }
}

export const SalesOrderStatusService = new SalesOrderStatusServiceClass();
